import { render, staticRenderFns } from "./SocialSecurityModal.vue?vue&type=template&id=e5f3c6d0&"
import script from "./SocialSecurityModal.vue?vue&type=script&lang=ts&"
export * from "./SocialSecurityModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports